import Okved from '@/modules/nsi/views/Okved.vue';
import OkvedCard from '@/modules/nsi/views/OkvedCard.vue';

import Countries from '../views/Countries.vue';
import CountriesGroups from '../views/CountriesGroups.vue';
import CountryCard from '../views/CountryCard.vue';
import CountryGroupCard from '../views/CountryGroupCard.vue';
import DictionaryItemCard from '../views/DictionaryItemCard.vue';
import DictionaryItems from '../views/DictionaryItems.vue';
import DictionaryWrapper from '../views/DictionaryWrapper.vue';
import DocumentTagCard from '../views/DocumentTagCard.vue';
import DocumentTags from '../views/DocumentTags.vue';
import DocumentTypeCard from '../views/DocumentTypeCard.vue';
import DocumentTypes from '../views/DocumentTypes.vue';
import FreeTradeAgreementTypeCard from '../views/FreeTradeAgreementTypeCard.vue';
import FreeTradeAgreementTypes from '../views/FreeTradeAgreementTypes.vue';
import Industries from '../views/Industries.vue';
import IndustryCard from '../views/IndustryCard.vue';
import InvestigationTypeCard from '../views/InvestigationTypeCard.vue';
import InvestigationTypes from '../views/InvestigationTypes.vue';
import MassMediaCategory from '../views/MassMediaCategory.vue';
import MassMediaCategoryCard from '../views/MassMediaCategoryCard.vue';
import MassMediaSmtk from '../views/MassMediaSmtk.vue';
import MassMediaSmtkCard from '../views/MassMediaSmtkCard.vue';
import MeasureKindCard from '../views/MeasureKindCard.vue';
import MeasureOrganProtectedMarketCard from '../views/MeasureOrganProtectedMarketCard.vue';
import MeasuresKinds from '../views/MeasuresKinds.vue';
import MeasuriesOrgansProtectedMarket from '../views/MeasuriesOrgansProtectedMarket.vue';
import MpkEventTypeCard from '../views/MpkEventTypeCard.vue';
import MpkEventTypes from '../views/MpkEventTypes.vue';
import MpkProjectStatusCard from '../views/MpkProjectStatusCard.vue';
import MpkProjectStatuses from '../views/MpkProjectStatuses.vue';
import NonTariffMeasure from '../views/NonTariffMeasure.vue';
import NonTariffMeasureCard from '../views/NonTariffMeasureCard.vue';
import NsiCountryCoverage from '../views/NsiCountryCoverage.vue';
import NsiCountryCoverageCard from '../views/NsiCountryCoverageCard.vue';
import NsiExportPotentialServiceTypeCard from '../views/NsiExportPotentialServiceTypeCard.vue';
import NsiExportPotentialServiceTypes from '../views/NsiExportPotentialServiceTypes.vue';
import NsiList from '../views/NsiList.vue';
import NsiMpkBusinessStatus from '../views/NsiMpkBusinessStatus.vue';
import NsiMpkBusinessStatusCard from '../views/NsiMpkBusinessStatusCard.vue';
import NsiMpkStatusCard from '../views/NsiMpkStatusCard.vue';
import NsiMpkStatuses from '../views/NsiMpkStatuses.vue';
import OrganizationRoleCard from '../views/OrganizationRoleCard.vue';
import OrganizationRoles from '../views/OrganizationRoles.vue';
import ProjectPurposeCard from '../views/ProjectPurposeCard.vue';
import ProjectPurposes from '../views/ProjectPurposes.vue';
import RegionsOfChina from '../views/RegionsOfChina.vue';
import SubjectRF from '../views/SubjectRF.vue';
import TaskTypeCard from '../views/TaskTypeCard.vue';
import TaskTypes from '../views/TaskTypes.vue';
import Tnved from '../views/Tnved.vue';
import TnvedCard from '../views/TnvedCard.vue';
import TnvedIndustry from '../views/TnvedIndustry.vue';
import TnvedIndustryCard from '../views/TnvedIndustryCard.vue';
import TnvedNonEnergy from '../views/TnvedNonEnergy.vue';
import TransportCard from '../views/TransportCard.vue';
import Transports from '../views/Transports.vue';

export const routes = [
  {
    path: '/Nsi/MpkProjectStatus',
    name: 'MpkProjectStatuses',
    component: MpkProjectStatuses,
  },
  {
    path: '/Nsi/MpkProjectStatus/:action/:id',
    name: 'MpkProjectStatusCard',
    component: MpkProjectStatusCard,
  },
  {
    path: '/Nsi/NonTariffMeasure',
    name: 'NonTariffMeasure',
    component: NonTariffMeasure,
  },
  {
    path: '/Nsi/NonTariffMeasure/:action/:id',
    name: 'NonTariffMeasureCard',
    component: NonTariffMeasureCard,
  },
  {
    path: '/Nsi/NsiMpkStatus',
    name: 'NsiMpkStatuses',
    component: NsiMpkStatuses,
  },
  {
    path: '/nsi/status-ds',
    name: 'NsiMpkBusinessStatus',
    component: NsiMpkBusinessStatus,
  },
  {
    path: '/Nsi/NsiMpkBusinessStatusCard/:action/:id',
    name: 'NsiMpkBusinessStatusCard',
    component: NsiMpkBusinessStatusCard,
  },
  {
    path: '/Nsi/NsiMpkStatus/:action/:id',
    name: 'NsiMpkStatusCard',
    component: NsiMpkStatusCard,
  },
  {
    path: '/Nsi/NsiCountryCoverage',
    name: 'NsiCountryCoverage',
    component: NsiCountryCoverage,
  },
  {
    path: '/Nsi/NsiCountryCoverage/:action/:id',
    name: 'NsiCountryCoverageCard',
    component: NsiCountryCoverageCard,
  },
  {
    path: '/Nsi/Countries',
    name: 'Countries',
    component: Countries,
  },
  {
    path: '/Nsi/Countries/:action/:id',
    name: 'CountryCard',
    component: CountryCard,
  },
  {
    path: '/Nsi/Industry',
    name: 'Industries',
    component: Industries,
  },
  {
    path: '/Nsi/Industry/:action/:id',
    name: 'IndustryCard',
    component: IndustryCard,
  },
  {
    path: '/Nsi/MpkEventType',
    name: 'MpkEventTypes',
    component: MpkEventTypes,
  },
  {
    path: '/Nsi/MpkEventType/:action/:id',
    name: 'MpkEventTypeCard',
    component: MpkEventTypeCard,
  },
  {
    path: '/Nsi/ProjectPurpose',
    name: 'ProjectPurposes',
    component: ProjectPurposes,
  },
  {
    path: '/Nsi/ProjectPurpose/:action/:id',
    name: 'ProjectPurposeCard',
    component: ProjectPurposeCard,
  },
  {
    path: '/nsi/NsiList',
    name: 'NsiList',
    component: NsiList,
  },
  {
    path: '/nsi/tnved',
    name: 'Tnved',
    component: Tnved,
  },
  {
    path: '/nsi/tnved/:action/:id',
    name: 'TnvedCard',
    component: TnvedCard,
  },
  {
    path: '/nsi/tnvedNonEnergy',
    name: 'TnvedNonEnergy',
    component: TnvedNonEnergy,
  },
  {
    path: '/nsi/okved',
    name: 'Okved',
    component: Okved,
  },
  {
    path: '/nsi/okved/:action/:id',
    name: 'OkvedCard',
    component: OkvedCard,
  },
  {
    path: '/nsi/transport',
    name: 'Transports',
    component: Transports,
  },
  {
    path: '/nsi/transport/:action/:id',
    name: 'TransportCard',
    component: TransportCard,
  },
  {
    path: '/nsi/countriesGroups',
    name: 'countriesGroups',
    component: CountriesGroups,
  },
  {
    path: '/nsi/countriesGroups/:action/:id',
    name: 'CountryGroupCard',
    component: CountryGroupCard,
  },
  {
    path: '/nsi/MeasureKind',
    name: 'MeasuresKinds',
    component: MeasuresKinds,
  },
  {
    path: '/nsi/MeasureKind/:action/:id',
    name: 'MeasureKindCard',
    component: MeasureKindCard,
  },
  {
    path: '/nsi/MeasuriesOrgansProtectedMarket',
    name: 'MeasuriesOrgansProtectedMarket',
    component: MeasuriesOrgansProtectedMarket,
  },
  {
    path: '/nsi/MeasureOrganProtectedMarket/:action/:id',
    name: 'MeasureOrganProtectedMarketCard',
    component: MeasureOrganProtectedMarketCard,
  },
  {
    path: '/nsi/TaskTypes',
    name: 'TaskTypes',
    component: TaskTypes,
  },
  {
    path: '/nsi/TaskTypes/:action/:id',
    name: 'TaskTypeCard',
    component: TaskTypeCard,
  },
  {
    path: '/nsi/DocumentTags',
    name: 'DocumentTags',
    component: DocumentTags,
  },
  {
    path: '/nsi/DocumentTags/:action/:id',
    name: 'DocumentTagCard',
    component: DocumentTagCard,
  },
  {
    path: '/nsi/DocumentTypes',
    name: 'DocumentTypes',
    component: DocumentTypes,
  },
  {
    path: '/nsi/DocumentTypes/:action/:id',
    name: 'DocumentTypeCard',
    component: DocumentTypeCard,
  },
  {
    path: '/nsi/investigationtypes',
    name: 'InvestigationTypes',
    component: InvestigationTypes,
  },
  {
    path: '/nsi/investigationtypes/:action/:id',
    name: 'InvestigationTypeCard',
    component: InvestigationTypeCard,
  },
  {
    path: '/nsi/OrganizationRoles',
    name: 'OrganizationRoles',
    component: OrganizationRoles,
  },
  {
    path: '/nsi/OrganizationRoles/:action/:id',
    name: 'OrganizationRoleCard',
    component: OrganizationRoleCard,
  },
  {
    path: '/nsi/MassMediaCategory',
    name: 'MassMediaCategory',
    component: MassMediaCategory,
  },
  {
    path: '/nsi/MassMediaCategory/:action/:id',
    name: 'MassMediaCategoryCard',
    component: MassMediaCategoryCard,
  },
  {
    path: '/nsi/MassMediaSmtk',
    name: 'MassMediaSmtk',
    component: MassMediaSmtk,
  },
  {
    path: '/nsi/MassMediaSmtk/:action/:id',
    name: 'MassMediaSmtkCard',
    component: MassMediaSmtkCard,
  },
  {
    path: '/nsi/dictionary/:name',
    name: 'DictionaryWrapper',
    component: DictionaryWrapper,
    children: [
      {
        path: '/nsi/dictionary/:name',
        name: 'dictionaryItems',
        component: DictionaryItems,
      },
      {
        path: '/nsi/dictionary/:name/:action/:id',
        name: 'dictionaryItemCard',
        component: DictionaryItemCard,
      },
    ],
  },
  {
    path: '/nsi/dictionary/tnvedIndustry',
    name: 'TnvedIndustry',
    component: TnvedIndustry,
  },
  {
    path: '/nsi/dictionary/tnvedIndustry/:action/:id',
    name: 'TnvedIndustryCard',
    component: TnvedIndustryCard,
  },
  {
    path: '/nsi/dictionary/freeTradeAgreementType',
    name: 'FreeTradeAgreementTypes',
    component: FreeTradeAgreementTypes,
  },
  {
    path: '/nsi/dictionary/freeTradeAgreementType/:action/:id',
    name: 'FreeTradeAgreementTypeCard',
    component: FreeTradeAgreementTypeCard,
  },
  {
    path: '/nsi/RegionsChina',
    name: 'RegionsOfChina',
    component: RegionsOfChina,
  },
  {
    path: '/nsi/subjectRf',
    name: 'SubjectRF',
    component: SubjectRF,
  },
  {
    path: '/nsi/nsiExportPotentialServiceType',
    name: 'NsiExportPotentialServiceTypes',
    component: NsiExportPotentialServiceTypes,
  },
  {
    path: '/nsi/nsiExportPotentialServiceType/:action/:id',
    name: 'NsiExportPotentialServiceTypeCard',
    component: NsiExportPotentialServiceTypeCard,
  },
];
